import React from 'react';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import ChangePasswordForm from './change-password-form';

type SecurityFormViewProps = {
  passwordSubmissionError: ApiError | false,
  handleSubmitPassword: (data: any, onSuccess: any) => void,
  onNavigateBack: () => void,
};

const SecurityFormView = ({
  passwordSubmissionError,
  handleSubmitPassword,
  onNavigateBack,
}:SecurityFormViewProps) => (
  <ChangePasswordForm
    submissionError={passwordSubmissionError}
    onSubmit={handleSubmitPassword}
    onCancel={onNavigateBack}
  />
);

export default SecurityFormView;
